/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Datasets_Create_Space_DescriptionInputs */



/**
* | output |
* | --- |
* | "A dataset space holds structured tables the assistant can query. Give it a clear name." |
*
* @param {Datasets_Create_Space_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const datasets_create_space_description = /** @type {((inputs?: Datasets_Create_Space_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Create_Space_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ein Datensatz-Bereich enthält strukturierte Tabellen, die der Assistent abfragen kann. Geben Sie ihm einen klaren Namen.")
	return /** @type {LocalizedString} */ ("A dataset space holds structured tables the assistant can query. Give it a clear name.")
});